import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Container,
  // useTheme,
  // useMediaQuery,
  Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

// نموذج للأقسام الرئيسية
const categories = [
  {
    id: 1,
    name: 'الهواتف الذكية',
    image: 'https://via.placeholder.com/300x300?text=Smartphones',
    count: 120,
    color: '#3f51b5'
  },
  {
    id: 2,
    name: 'الحواسيب',
    image: 'https://via.placeholder.com/300x300?text=Laptops',
    count: 85,
    color: '#f50057'
  },
  {
    id: 3,
    name: 'الإكسسوارات',
    image: 'https://via.placeholder.com/300x300?text=Accessories',
    count: 230,
    color: '#ff9800'
  },
  {
    id: 4,
    name: 'الساعات الذكية',
    image: 'https://via.placeholder.com/300x300?text=Smartwatches',
    count: 75,
    color: '#4caf50'
  },
  {
    id: 5,
    name: 'التلفزيونات',
    image: 'https://via.placeholder.com/300x300?text=TVs',
    count: 45,
    color: '#9c27b0'
  },
  {
    id: 6,
    name: 'الكاميرات',
    image: 'https://via.placeholder.com/300x300?text=Cameras',
    count: 28,
    color: '#2196f3'
  }
];

interface CategoryShowcaseProps {
  title?: string;
}

const CategoryShowcase: React.FC<CategoryShowcaseProps> = ({
  title = 'تسوق حسب الأقسام'
}) => {
  // يمكن استخدام هذه المتغيرات لاحقاً لتحسين تجربة المستخدم على الأجهزة المحمولة
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{
      py: 6,
      backgroundColor: '#f5f5f5',
      width: '100vw',
      marginLeft: 'calc(-50vw + 50%)',
      marginRight: 'calc(-50vw + 50%)'
    }}>
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4, lg: 5 } }}>
        {/* عنوان القسم */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            className="section-title"
            sx={{
              fontWeight: 'bold',
              position: 'relative',
              '&:after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                right: 0,
                width: 60,
                height: 4,
                backgroundColor: 'primary.main',
                borderRadius: 2
              }
            }}
          >
            {title}
          </Typography>

          <Button
            component={RouterLink}
            to="/categories"
            color="primary"
            endIcon={<ArrowBack />}
            sx={{ fontWeight: 'bold' }}
          >
            جميع الأقسام
          </Button>
        </Box>

        {/* شبكة الأقسام */}
        <Grid container spacing={3}>
          {categories.map((category) => (
            <Grid item xs={6} sm={4} md={2} key={category.id}>
              <Card
                component={RouterLink}
                to={`/category/${category.id}`}
                sx={{
                  height: '100%',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                  },
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 120,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: category.color,
                    position: 'relative'
                  }}
                >
                  <CardMedia
                    component="img"
                    image={category.image}
                    alt={category.name}
                    sx={{
                      height: 80,
                      width: 80,
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1)',
                      zIndex: 1
                    }}
                  />

                  {/* نمط زخرفي */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.2) 10%, transparent 10.5%)',
                      backgroundSize: '20px 20px',
                      opacity: 0.5
                    }}
                  />
                </Box>

                <CardContent sx={{ textAlign: 'center', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{
                      fontWeight: 'bold',
                      color: 'text.primary',
                      mb: 1
                    }}
                  >
                    {category.name}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    {category.count} منتج
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CategoryShowcase;
